<template>
  <fieldset>
    <FormulateInput
      v-model="selectedOption"
      type="select"
      :name="fieldName"
      :options="options"
      :label="i18n.form.labels.location"
      :help="i18n.form.help.location"
      :validation="isRequired ? 'required' : ''"
      :validation-messages="i18n.form.validations.location"
      error-behavior="blur"
    />
    <kf-loader
      v-if="isLoading"
      loader-size="sm"
      loader-color="primary"
    />
  </fieldset>
</template>

<script>
import KfLoader from '@/components/loader/Loader.vue';
import axios from 'axios';

export default {
  name: 'FieldsDropdownCityLocations',
  components: {
    KfLoader,
  },
  props: {
    i18n: {
      type: Object,
      default: () => {},
    },
    fieldName: {
      type: String,
      default: () => 'city',
    },
    isRequired: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: () => 'Smallsteps',
    },
    city: {
      type: String,
      default: () => null,
    },
    careTypeFilter: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      options: [],
      selectedOption: null,
      isLoading: false,
    };
  },
  watch: {
    city(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedOption = null;
        if (newValue) {
          this.getCityLocationOptions(this.city, this.careTypeFilter).then((cl) => (this.options = cl));
        }
      }
    },
  },
  methods: {
    getCityLocationOptions(currentCity, careTypeFilter) {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        const params = {
          label: this.label,
          city: currentCity
        };

        if (careTypeFilter) {
          params.careTypeFilter = careTypeFilter;
        }

        axios
          .get(`/umbraco/api/content/getlocations`, { params })
          .then((response) => {
            const data = response.data;
            let locations = [];

            // Add 'empty' option
            locations.push({
              value: '',
              label: `-- ${this.i18n.form.labels.location.toLowerCase()} --`,
            });

            // Filter (optional) and covert API data
            data.Location.forEach((loc) => {
              if (this.filterLocationsOnString) {
                if (loc.name.search(this.filterLocationsOnString) < 0) return;
              }
              locations.push({ value: loc.name, label: loc.name });
            });

            resolve(locations);
          })
          .catch((e) => {
            reject(e);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>
